import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RxntProgressTimeoutComponent } from './rxnt-progress-timeout.component';

@NgModule({
  declarations: [
    RxntProgressTimeoutComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntProgressTimeoutComponent,
  ],
})
export class RxntProgressTimeoutModule {
}
